import { createContext } from "react";

export type APIType = {
  API: {
    GET: {
      PRODUCTS: string;
      MIXES: string;
    };
    POST: {
      CALCULATE_BY_PRODUCTS: string;
      AVG_INTEREST: string;
      CALCULATE_MIXES: string;
    };
  };
  URLS: {
    TALK_WITH_US: {
      SCRIPT_SRC: string;
      LIGHTNING: string;
    },
    WRITE_TO_US: string;
    MORTGAGE_REQUEST: string;
  };
};

export const APIContext = createContext<APIType | undefined>(undefined);
